import React, { useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";

import TableHeadCell from "./TableHeadCell";
import HeaderCheckbox from "./HeaderCheckbox";
import StagingCheckbox from "./StagingCheckbox";
import AdditionalInfo from "./AdditionalInfo";

export default function TableDisplay({
  data,
  tableSettings,
  dataSettings,
  sortColumn,
  sortDescending,
  setSortColumn,
  setSortDescending,
}) {
  const { uid, display } = dataSettings;

  // State for modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // useState to keep track of which datum
  // should appear on the additional Information modal
  const [selectedAdditionalInfoDatum, setSelectedAdditionalInfoDatum] =
    useState(null);

  const {
    columnsOnMainTable,
    columnProperties,
    columnsOnAdditionalInfo,
    colForTitleForAdditionalInfoPage,
  } = tableSettings;

  // Helpers for rendering

  const renderTableHead = (colNames) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell>
            <HeaderCheckbox></HeaderCheckbox>
          </TableCell>
          {colNames.map((colName, i) => {
            const key = `col-${i}`;
            return (
              <TableCell key={key}>
                <TableHeadCell
                  columnName={colName}
                  columnDisplayName={display[colName]}
                  sortColumn={sortColumn}
                  sortDescending={sortDescending}
                  setSortColumn={setSortColumn}
                  setSortDescending={setSortDescending}
                ></TableHeadCell>
              </TableCell>
            );
          })}
          <TableCell key={"additional-info"}>Additional Info</TableCell>
        </TableRow>
      </TableHead>
    );
  };

  const renderTableBody = (data, colNames) => {
    return data.map((datum, i) => renderTableRow(datum, colNames, i));
  };

  const renderTableRow = (datum, colNames, i) => {
    return (
      <TableRow
        key={datum[uid]}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          "&:nth-of-type(odd)": {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <TableCell>
          <StagingCheckbox uid={datum[uid]}></StagingCheckbox>
        </TableCell>
        {colNames.map((colName) => {
          return (
            <TableCell key={`${datum[colName]}::${i}::${colName}`}>
              {datum[colName]}
            </TableCell>
          );
        })}
        <TableCell>
          <IconButton
            aria-label="delete"
            onClick={() => {
              setSelectedAdditionalInfoDatum(datum);
              handleOpen();
            }}
            size="small"
          >
            <InfoIcon fontSize="inherit" sx={{ color: "#999" }} />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  // Main Render Function
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        {renderTableHead(columnsOnMainTable)}
        <TableBody>{renderTableBody(data, columnsOnMainTable)}</TableBody>
      </Table>
      <AdditionalInfo
        open={open}
        handleClose={handleClose}
        columnsOnAdditionalInfo={columnsOnAdditionalInfo}
        colForTitleForAdditionalInfoPage={colForTitleForAdditionalInfoPage}
        datum={selectedAdditionalInfoDatum}
        columnProperties={columnProperties}
      ></AdditionalInfo>
    </TableContainer>
  );
}
